import React from 'react'
import { TransitionGroup } from 'react-transition-group'
import { css, cx } from '@emotion/css'

const styleListCss = css`
  padding: 0px;
  margin: 0px;
`

interface Props {
  readonly className?: string
  readonly [key: string]: any
}

export function StyledTransitionGroup({ className = '', ...props }: Props) {
  return (
    <TransitionGroup
      className={className ? cx(styleListCss, className) : styleListCss}
      {...props}
    />
  )
}
